import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { CruisePayment } from '../../../../../constants';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';

const CruisePaymentFilter = ({
  onSearch, label, labelSuggest, selectedOption,
}) => {
  const { tripsSearch } = useSelector((store) => store.trip);

  const options = [{
    suggests: [{
      value: CruisePayment.FINAL_PAYMENT,
      label: labelSuggest,
    }],
    label: '',
    value: '',
  }];

  const handleCruisePayment = useCallback((selectedOptionsValue) => {
    const searchObj = {
      ...tripsSearch.searchObj,
      [selectedOption]: selectedOptionsValue,
      page: 1,
    };
    onSearch(searchObj);
  }, [onSearch, tripsSearch.searchObj, selectedOption]);

  return (
    <CheckboxSelectFilter
      onChange={handleCruisePayment}
      options={options[0].suggests}
      values={tripsSearch.searchObj[selectedOption] || []}
      label={label}
      variant="outline"
      sortField="discounts"
      filterMaxWidthClass="max-w"
      widthInside={tripsSearch.searchObj[selectedOption][0] ? 'max-w-filter' : 'max-w-full'}
    />
  );
};

CruisePaymentFilter.propTypes = {
  onSearch: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  labelSuggest: PropTypes.string.isRequired,
  selectedOption: PropTypes.string.isRequired,
};

export default CruisePaymentFilter;
